export default __webpack_public_path__ + "static/media/inspired-award-800.d2f4ce10.png";